import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { IParamEventoUsuario } from '../../config-evento-usuario/crear-editar-config-evento-usuario-dialog/crear-editar-config-evento-usuario-dialog.component';
import { HelperService } from '../../../../auxiliares/servicios/helper.service';
import { ListadoConfigEventoUsuarioComponent } from '../../config-evento-usuario/listado-config-evento-usuario/listado-config-evento-usuario.component';
import { CategoriaGrupo, TipoEntidad } from 'modelos/src';
import { MatIconModule } from '@angular/material/icon';
import { BotonComponent } from '../../../../componentes/botones/boton.component';

@Component({
  selector: 'app-listado-eventos-personalizados-grupo',
  templateUrl: './listado-eventos-personalizados-grupo.component.html',
  styleUrl: './listado-eventos-personalizados-grupo.component.scss',
  standalone: true,
  imports: [ListadoConfigEventoUsuarioComponent, BotonComponent, MatIconModule],
})
export class ListadoEventosPersonalizadosGrupoComponent implements OnInit {
  private activatedRoute = inject(ActivatedRoute);

  public name = 'ListadoEventosPersonalizadosGrupoComponent';
  public idGrupo: string;
  public nombreGrupo: string;
  public categoriaGrupo: CategoriaGrupo;
  public loading: boolean = false;
  public params?: IParamEventoUsuario;

  public volver(): void {
    window.history.back();
  }

  async ngOnInit(): Promise<void> {
    const params = await firstValueFrom(this.activatedRoute.paramMap);
    this.nombreGrupo = this.activatedRoute.snapshot.queryParamMap.get('nombre');
    this.idGrupo = params.get('id');
    this.categoriaGrupo = params.get('categoria') as CategoriaGrupo;

    let tipoEntidad: TipoEntidad;
    let botonCrear: boolean;

    switch (this.categoriaGrupo) {
      case 'Luminaria':
        tipoEntidad = 'Luminaria';
        botonCrear =
          HelperService.getConfigCliente().moduloLuminarias?.crearDispositivos;
        break;
      case 'Línea de colectivo':
        tipoEntidad = 'Vehiculo';
        botonCrear =
          HelperService.getConfigCliente().moduloColectivos?.crearDispositivos;
        break;
      case 'Flota':
        tipoEntidad = 'Vehiculo';
        botonCrear =
          HelperService.getConfigCliente().moduloVehiculos?.crearVehiculos;
        break;
      case 'Activo':
        tipoEntidad = 'Activo';
        botonCrear =
          HelperService.getConfigCliente().moduloVehiculos?.crearVehiculos;
        break;
      default:
        break;
    }

    this.params = {
      tipoEntidad,
      agrupacion: 'Grupo',
      idGrupo: this.idGrupo,
      botonCrear,
      crear: 'Dialog',
    };
  }
}
